import React from 'react';
import { ExternalLink } from 'lucide-react';

interface MapFallbackProps {
  className?: string;
}

const MapFallback: React.FC<MapFallbackProps> = ({ className = '' }) => {
  const handleDirectionsClick = () => {
    const address = '16 Friday Street, Minehead, TA24 5UA';
    const encodedAddress = encodeURIComponent(address);
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const googleMapsUrl = isMobile 
      ? `https://maps.google.com/maps?q=${encodedAddress}`
      : `https://www.google.com/maps/dir/?api=1&destination=${encodedAddress}`;
    
    try {
      window.open(googleMapsUrl, '_blank');
    } catch (error) {
      console.error('Failed to open Google Maps:', error);
      if (isMobile) {
        window.location.href = googleMapsUrl;
      }
    }
  };

  // Address for Kiss Coffee Minehead
  const locationLabel = 'Kiss Coffee Minehead, 16 Friday Street, Minehead, TA24 5UA, UK';
  const encodedLocation = encodeURIComponent(locationLabel);
  
  return (
    <div className={className}>
      <div 
        className="w-full rounded-lg shadow-lg overflow-hidden"
        style={{ minHeight: '300px' }}
      >
        {/* Embedded Google Maps iframe */}
        <iframe
          title="Kiss Coffee Minehead Location"
          src={`https://maps.google.com/maps?q=${encodedLocation}&hl=en&z=15&output=embed`}
          width="100%"
          height="100%"
          style={{ border: 0, minHeight: '300px' }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
      
      {/* Address and button below the map */}
      <div className="mt-3 flex items-center justify-between">
        <p className="text-sm text-gray-700">
          16 Friday Street, Minehead, TA24 5UA
        </p>
        <button
          onClick={handleDirectionsClick}
          className="flex items-center gap-1 bg-red-600 text-white px-2 py-1 rounded-md hover:bg-red-700 transition-colors duration-200 text-xs font-medium"
        >
          <ExternalLink className="h-3 w-3" />
          Directions
        </button>
      </div>
    </div>
  );
};

export default MapFallback;
